import React, { useState, useEffect } from "react";
import "./style.css";
import httpApis from "../../services/HttpApis";
import { useNavigate } from "react-router-dom"; // <--- import useNavigate

function UpdateProfile() {
  const [name, setName] = useState("");
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [avatars, setAvatars] = useState([]);
  const [profileId, setProfileId] = useState(null); // store profile id
  const navigate = useNavigate(); // <--- initialize navigate

  useEffect(() => {
    // Get selected profile from localStorage
    const storedAvatarId = localStorage.getItem("selectedAvatar");
    const storedName = localStorage.getItem("selectedAvatarName"); // we'll save name too

    if (storedAvatarId) {
      setSelectedAvatar(storedAvatarId);
      setProfileId(storedAvatarId); // assuming profileId = avatarId
    }

    if (storedName) {
      setName(storedName);
    }

    const fetchAvatars = async () => {
      try {
        const response = await httpApis.getAllAvatarImg();

        if (response?.data?.data) {
          setAvatars(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching avatars:", error);
      }
    };

    fetchAvatars();
  }, []);

const handleUpdate = async () => {
  try {
    const body = {};

    // Only include name if it is changed
    const storedName = localStorage.getItem("selectedAvatarName");
    if (name && name !== storedName) {
      body.name = name;
    }

    // Only include avatar if it is changed
    const storedAvatarId = localStorage.getItem("selectedAvatar");
    if (selectedAvatar && selectedAvatar !== storedAvatarId) {
      body.avatar = selectedAvatar.toString();
    }

    // Optional defaults (only include if needed)
    body.language = "english";
    body.preferences = "";

    const response = await httpApis.postUpdateProfile(profileId, body);
    console.log("Profile updated successfully:", response);

    // Clear localStorage after successful update
    localStorage.removeItem("selectedAvatar");
    localStorage.removeItem("selectedAvatarName");

    navigate("/profile", { replace: true });
  } catch (error) {
    console.error("Error updating profile:", error);
  }
};


const handleDelete = async () => {
  try {
    const response = await httpApis.deleteProfile(profileId); // use profileId from localStorage
    console.log("Profile deleted successfully:", response);

    // Clear localStorage after successful delete
    localStorage.removeItem("selectedAvatar");
    localStorage.removeItem("selectedAvatarName");

    navigate("/profile", { replace: true });
  } catch (error) {
    console.error("Error deleting profile:", error);
  }
};


  return (
    <div className="profile-container">
      <div className="profile-content">
        {/* Header */}
        <div className="update-header">
          <h1 className="profile-title">Update Profile</h1>
          <button className="delete-btn" onClick={handleDelete}>Delete</button>
        </div>

        {/* Avatars */}
        <div className="avatar-container">
          {avatars.map((avatar, index) => (
            <div key={avatar.id || index} className="avatar-wrapper">
              <button
                className={`avatar-button ${selectedAvatar === avatar.id ? "selected" : ""}`}
                onClick={() => setSelectedAvatar(avatar.id)}
              >
                <img
                  src={avatar.image_url || avatar.avatar_img}
                  alt={avatar.name || "avatar"}
                  className="avatar-image"
                />
              </button>
            </div>
          ))}
        </div>

        {/* Name Input */}
        <div className="profile-input-container">
          <input
            className="profile-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        {/* Update Button */}
        <div className="button-container profile-button-spacing">
          <button className="profile-button" onClick={handleUpdate}>Update</button>
        </div>
      </div>
    </div>
  );
}

export default UpdateProfile;
